import styles from '../DiagramTextNode.module.css';

export const TEXT_COLOR_CLASS_NAMES = [
  styles.colorGray200,
  styles.colorGray400,
  styles.colorGray600,
  styles.colorGray800,
  styles.colorBlack,
  styles.colorSky,
  styles.colorLink,
  styles.colorOcean,
  styles.colorWarningAlt,
  styles.colorWarning,
  styles.colorDanger,
  styles.colorSuccess,
];
